import React, { useEffect } from 'react';

import Hero from './hero';
import InfoTypes from '../common/InfoTypes';
import Faq from '../common/FAQ';
import VerticalFeatures from '../common/VerticalFeatures';
import BrandsShowcase from '../common/BrandsShowcase';
import ContactInfo from '../common/ContactInfo';
import Apps from '../home/apps';
import PartnerInvitation from './PartnerInvitation';
import RecommendedArticles from '../common/RecommendedArticles';
import Reviews from '../common/Reviews';
import ReviewsCount from './ReviewsCount';
import InfoBanner from './info-banner';
import { scrollToElement } from '../../utils/useScrollToHash';
import { useLocale } from '../../utils/locale';

export const HOW_IT_WORKS_ID = 'how-it-works';

export const scrollToHowItWorksSection = () => {
  const target = document.getElementById(HOW_IT_WORKS_ID);

  // Ensure the target exists before scrolling
  setTimeout(() => {
    scrollToElement(target);
  }, 100);
};

const FlexPayProduct = ({
  hero,
  reviewsCount,
  infoTypes,
  infoTypesAlt,
  brandsShowcase,
  verticalFeatures,
  partnerInvitation,
  faq,
  relatedArticles,
  reviews,
  downloadApps,
  contact
}) => {
  const { isCanada, isCanadaFrench } = useLocale();

  useEffect(() => {
    if (isCanada) {
      scrollToHowItWorksSection();
    }
  }, [isCanada]);

  return (
    <>
      <InfoBanner />
      {hero ? <Hero {...hero} /> : null}
      {reviewsCount ? <ReviewsCount {...{ reviews: reviewsCount }} borderless topMargin="xl" /> : null}
      {infoTypes ? <InfoTypes {...{ infoTypes }} borderless /> : null}
      {infoTypesAlt ? <InfoTypes {...{ infoTypes: infoTypesAlt }} borderless id={HOW_IT_WORKS_ID} /> : null}
      {brandsShowcase ? <BrandsShowcase {...{ brandsShowcase }} /> : null}
      {verticalFeatures ? <VerticalFeatures {...{ verticalFeatures }} /> : null}
      {partnerInvitation ? <PartnerInvitation {...{ partnerInvitation }} /> : null}
      {relatedArticles?.length ? (
        <RecommendedArticles {...{ relatedArticles }} borderless padding={['2xl', 'none', 'none']} />
      ) : null}
      {faq ? <Faq {...{ faq }} /> : null}
      {reviews && !isCanadaFrench ? <Reviews {...{ reviews }} borderless /> : null}
      {downloadApps ? <Apps {...{ downloadApps }} borderless /> : null}
      {contact ? <ContactInfo {...{ contact, borderless: true }} /> : null}
    </>
  );
};

export default FlexPayProduct;
